import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccessAlarmsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"access_alarms"}/>
}
